module.exports = __webpack_public_path__ + "static/media/LYjMdG_8nE8jDLRagCY.8cc10f08.woff2";